module.exports = __webpack_public_path__ + "static/media/demovideos.381ce802.mp4";